<template>
  <div
    class="d-flex flex-column justify-content-between"
    :class="['k-profile__block-wrapper', {'k-profile__editing-block-wrapper': isEditing}, { 'mt-3': isMobile }]">
    <!--
    <div class="nav justify-content-center mb-4 flex-nowrap" v-if="isMobile && user">
      <span
        class="nav-item main-menu__item-wrapper w-100 d-flex justify-content-center"
        :class="{ active: !profileModeUser }"
        @click="switchMode(false)"
      >
        <span class="main-menu__item nav-link">Профиль</span>
      </span>
      <span
        class="nav-item main-menu__item-wrapper w-100 d-flex justify-content-center"
        :class="{ active: profileModeUser }"
        @click="switchMode(true)"
      >
        <span class="main-menu__item nav-link">Настройки</span>
      </span>
    </div>
    -->
    <div class="k-profile__buttons" v-if="!isMobile">
      <a
        href="#"
        @click.prevent="removeProfileHandler"
        v-if="isEditing && !user"
        class="k-profile__remove-button"
      >
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8889 3.07692H13.2222V2.30769C13.2222 1.03514 12.1756 0 10.8889 0H7.77778C6.49109 0 5.44444 1.03514 5.44444 2.30769V3.07692H0.777778C0.347861 3.07692 0 3.42135 0 3.84615C0 4.27096 0.347861 4.61538 0.777778 4.61538H1.55556V16.1538C1.55556 18.2745 3.30026 20 5.44444 20H13.2222C15.3664 20 17.1111 18.2745 17.1111 16.1538V4.61538H17.8889C18.3188 4.61538 18.6667 4.27096 18.6667 3.84615C18.6667 3.42135 18.3188 3.07692 17.8889 3.07692ZM7 2.30769C7 1.88365 7.34864 1.53846 7.77778 1.53846H10.8889C11.318 1.53846 11.6667 1.88365 11.6667 2.30769V3.07692H7V2.30769ZM15.5556 16.1538C15.5556 17.4264 14.5089 18.4615 13.2222 18.4615H5.44444C4.15776 18.4615 3.11111 17.4264 3.11111 16.1538V4.61538H15.5556V16.1538ZM8.55556 14.6154V8.46154C8.55556 8.03673 8.90342 7.69231 9.33333 7.69231C9.76325 7.69231 10.1111 8.03673 10.1111 8.46154V14.6154C10.1111 15.0402 9.76325 15.3846 9.33333 15.3846C8.90342 15.3846 8.55556 15.0402 8.55556 14.6154ZM5.44444 14.6154V8.46154C5.44444 8.03673 5.7923 7.69231 6.22222 7.69231C6.65214 7.69231 7 8.03673 7 8.46154V14.6154C7 15.0402 6.65214 15.3846 6.22222 15.3846C5.7923 15.3846 5.44444 15.0402 5.44444 14.6154ZM11.6667 14.6154V8.46154C11.6667 8.03673 12.0145 7.69231 12.4444 7.69231C12.8744 7.69231 13.2222 8.03673 13.2222 8.46154V14.6154C13.2222 15.0402 12.8744 15.3846 12.4444 15.3846C12.0145 15.3846 11.6667 15.0402 11.6667 14.6154Z"
            fill="#A3A3A3"
          />
        </svg>
      </a>
      <a href="#" @click.prevent="toggleEditing()" class="k-profile__edit-button">
        <div
          v-if="isEditing"
          :class="['k-profile__edit-button-img', {'active': isEditing && !isSaving, 'disabled': isEditing && isSaving}]"
        >Сохранить</div>
        <svg
          :class="['k-profile__edit-button-img', {'active': isEditing && !isSaving, 'disabled': isEditing && isSaving}]"
          v-else
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.0602 0.909317C17.791 -0.303106 15.793 -0.303106 14.5238 0.909317L1.29091 14.1414C1.22003 14.2123 1.1703 14.3016 1.14778 14.3993L0.0136789 19.3146C-0.0229366 19.4734 0.0148537 19.6402 0.11628 19.7677C0.217707 19.8951 0.371805 19.9695 0.534715 19.9693C0.575246 19.9695 0.615386 19.965 0.654743 19.9558L5.57022 18.8217C5.66793 18.7992 5.75721 18.7497 5.8281 18.6788L19.0602 5.44611C20.3133 4.19355 20.3133 2.16208 19.0602 0.909317ZM5.45019 17.5447L2.42482 14.5193L13.7676 3.17752L16.792 6.20231L5.45019 17.5447ZM1.9729 15.5796L4.38971 17.9962L1.24803 18.7215L1.9729 15.5796ZM18.3042 4.69011L17.5482 5.44611L14.5238 2.42152L15.2798 1.66551C16.1258 0.857233 17.4581 0.857233 18.3042 1.66551C19.1395 2.50062 19.1395 3.855 18.3042 4.69011Z"
            :fill="isEditing ? '#fff' : '#666666'"
            :fill-opacity="isEditing ? 1 : 0.6"
          />
        </svg>
      </a>
    </div>
    <div>
      <div class="k-profile__avatar">
        <avatar-letter
          :avatar="profile.avatar_url || temp_url"
          :title="profile.name"
          :size="120"
          :is-editing="isEditing"
          class="k-profile__avatar-block"
        >
          <image-cropper
            v-if="isEditing"
            :is-editing="!!(isEditing)"
            :onSave="onSaveAvatar"
          />
          <template #edit v-if="isEditing">
            <div class="k-profile__avatar-overlay">
              <svg
                class="k-profile__avatar-overlay-img"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6875 10.125C18.2383 10.125 19.5 8.86331 19.5 7.3125C19.5 5.76169 18.2383 4.5 16.6875 4.5C15.1367 4.5 13.875 5.76169 13.875 7.3125C13.875 8.86331 15.1367 10.125 16.6875 10.125ZM16.6875 6.375C17.2044 6.375 17.625 6.79556 17.625 7.3125C17.625 7.82944 17.2044 8.25 16.6875 8.25C16.1706 8.25 15.75 7.82944 15.75 7.3125C15.75 6.79556 16.1706 6.375 16.6875 6.375Z"
                  fill="white"
                  fill-opacity="0.6"
                />
                <path
                  d="M23.0625 0H0.9375C0.419719 0 0 0.419719 0 0.9375V23.0625C0 23.5803 0.419719 24 0.9375 24H23.0625C23.5803 24 24 23.5803 24 23.0625V0.9375C24 0.419719 23.5803 0 23.0625 0ZM22.125 22.125H1.875V16.3189L8.3475 9.68044L22.125 19.97V22.125ZM22.125 17.6297L8.811 7.68637C8.43412 7.40494 7.90716 7.44633 7.57875 7.78308L1.875 13.633V1.875H22.125V17.6297Z"
                  fill="white"
                  fill-opacity="0.6"
                />
              </svg>
            </div>
          </template>
        </avatar-letter>
      </div>
      <div
        class="error-message"
        v-if="hasError"
      >Ошибка при сохранении. Проверьте данные и попробуйте ещё раз</div>

      <!-- user edit -->
      <div v-if="localUser && profileModeUser && user" class="k-profile__block user-block">
        <div class="k-profile__field-group">
          <div class="k-profile__field-label">Имя</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__user"
            :value="localUser.name"
            @edit="editUserField"
            :is-editing="isEditing"
            name="name"
            key="user-name"
          ></base-editable-input>
        </div>
        <div class="k-profile__field-group">
          <div class="k-profile__field-label">Email</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__user"
            :value="localUser.email"
            @edit="editUserField"
            :is-editing="isEditing"
            name="email"
            key="user-email"
          ></base-editable-input>
        </div>
        <div class="k-profile__field-group">
          <div class="k-profile__field-label">Количество порций</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__user"
            :value="localProfile.portion_size"
            :view-value="getPortionsView(localProfile.portion_size)"
            @edit="editProfileField"
            :is-editing="isEditing"
            type="select"
            :options="{'0.5': '0.5 порции', '1': '1 порция', '1.5': '1.5 порции'}"
            name="portion_size"
            key="profile-portion_size"
          ></base-editable-input>
        </div>
      </div>

      <!-- profile edit -->
      <div v-else class="k-profile__block user-block">
        <div class="k-profile__field-group" v-if="!user">
          <div class="k-profile__field-label">Имя</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__user"
            :value="localProfile.name"
            @edit="editProfileField"
            :is-editing="isEditing"
            name="name"
            key="profile-name"
          ></base-editable-input>
        </div>

        <div class="k-profile__field-group">
          <div class="k-profile__field-label">Количество порций</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__user"
            :value="localProfile.portion_size"
            :view-value="getPortionsView(localProfile.portion_size)"
            @edit="editProfileField"
            :is-editing="isEditing"
            type="select"
            :options="{'0.5': '0.5 порции', '1': '1 порция', '1.5': '1.5 порции'}"
            name="portion_size"
            key="profile-portion_size"
          ></base-editable-input>
        </div>
      <!--
        <div class="k-profile__field">
          <div class="k-profile__field-label" v-if="isEditing">День рождения</div>
          <div class="k-profile__field-label" v-else>Возраст</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__profile"
            :value="profile.birth_date"
            @edit="editProfileField"
            :is-editing="isEditing"
            type="date"
            :view-value="userAge"
            name="birth_date"
            :suffix="` ${formattedAge}`"
            key="profile-age"
          ></base-editable-input>
        </div>
        <div class="k-profile__field">
          <div class="k-profile__field-label">Вес</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__profile"
            :value="profile.weight"
            @edit="editProfileField"
            :is-editing="isEditing"
            name="weight"
            suffix=" кг"
            key="profile-weight"
            type="number"
          ></base-editable-input>
        </div>
        <div class="k-profile__field">
          <div class="k-profile__field-label">Рост</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__profile"
            :value="profile.height"
            @edit="editProfileField"
            :is-editing="isEditing"
            name="height"
            suffix=" см"
            key="profile-height"
            type="number"
          ></base-editable-input>
        </div>
        <div class="k-profile__field">
          <div class="k-profile__field-label">Активность</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__profile"
            :value="profile.activity"
            @edit="editProfileField"
            :view-value="activities[profile.activity]"
            :is-editing="isEditing"
            name="activity"
            key="profile-height"
            :options="activities"
            type="select"
          ></base-editable-input>
        </div>
        <div class="k-profile__field">
          <div class="k-profile__field-label">Цель</div>
          <base-editable-input
            class="k-profile-editable k-profile-editable__profile"
            :value="profile.goal"
            :view-value="goals[profile.goal]"
            @edit="editProfileField"
            :is-editing="isEditing"
            name="goal"
            key="profile-height"
            :options="goals"
            type="select"
          ></base-editable-input>
        </div>
        -->
      </div>
    </div>

    <!-- dots
    <div class="k-profile__user-block-mode mt-auto mb-3" v-if="user && !isMobile">
      <div :class="['k-profile-dot', { active: profileModeUser }]" @click="switchMode(true)"></div>
      <div :class="['k-profile-dot', { active: !profileModeUser }]" @click="switchMode(false)"></div>
    </div>
    -->

    <div class="k-profile__profile-button mt-2" v-if="!isEditing" @click="openCalories()">
      Рассчитать калорийность и БЖУ
    </div>

    <div v-if="isMobile" class="mt-2 mb-5">
      <div class="k-profile__profile-button mb-2" v-if="isEditing" @click="toggleEditing()">
        Сохранить
      </div>
      <div class="k-profile__profile-button k-profile__profile-button--red mb-2" v-if="isEditing && profile.id && !user" @click="removeProfileHandler">
        Удалить
      </div>
      <div
        class="k-profile__edit-button mt-3"
        @click="toggleEditing(true)"
      >
        {{ isEditing ? 'Отменить' : 'Редактировать профиль' }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseEditableInput from "@/components/BaseEditableInput";
import TheAvatarLetter from "@/components/TheAvatarLetter";
import ImageCropper from "@/components/TheImageCropper";
import { LOADING_STATUS } from "@/constants";
import { objectWithKeys, declOfNum } from "../utils/helper";
import { mapGetters } from 'vuex';

export default {
  name: "UserProfileBlock",
  components: {
    BaseEditableInput,
    ImageCropper,
    "avatar-letter": TheAvatarLetter
  },
  props: {
    profile: {
      name: "profile",
      default: () => ({})
    },
    user: {
      name: "user",
      type: Object,
      required: false
    },
    editingMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      temp_url: null,
      temp_blob: null,
      wasEdited: false,
      isEditing: this.editingMode,
      hasError: false,
      localUser: this.user ? Object.assign({}, this.user) : null,
      localProfile: this.profile.id
        ? Object.assign(
            {},
            objectWithKeys(this.profile, [
              "id",
              "portion_size",
              "height",
              "weight",
              "birth_date",
              "name"
            ])
          )
        : {
          portion_size: 1,
          name: '',
        },
      profileModeUser: true, // user or profile
    };
  },
  computed: {
    ...mapGetters({
      activities: 'getActivityTypes',
      goals: 'getGoalTypes',
    }),
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'xs';
    },
    isSaving() {
      return this.$store.state.saveProfileStatus === LOADING_STATUS.LOADING;
    },
    userAge() {
      if (!this.localProfile || !this.localProfile.birth_date) {
        return 1;
      }
      const profileBdayYear = this.localProfile.birth_date.split("-")[0];
      const currentYear = new Date().getFullYear();
      return currentYear - profileBdayYear;
    },
    formattedAge() {
      return declOfNum(this.userAge, ["год", "года", "лет"]);
    }
  },
  watch: {
    editingMode(value) {
      this.isEditing = value;
    },
    user(newValue) {
      this.localUser = Object.assign({}, newValue);
    },
    profile(newValue) {
      console.log('PROFILE CHANGE', newValue)
      this.localProfile = objectWithKeys(newValue, [
        "id",
        "portion_size",
        "height",
        "weight",
        "birth_date",
        "name"
      ]);

    }
  },

  methods: {
    getPortionsView(size) {
      switch (size) {
        case 0.5: return '0.5 порции'
        case 1: return '1 порция'
        case 1.5: return '1.5 порции'
        default: return `${size} порции`
      }
    },
    openCalories() {
      this.$router.push({ name: 'Onboarding', params: { data: this.profile, from: 'Profile' }, query: { action: 'edit' } })
    },
    toggleEditing(force = false) {
      if (this.isSaving) {
        return;
      }

      if (force) {
        this.isEditing = !this.isEditing;

        if (!this.profile.id) {
          this.$emit('remove-new');
        }
        return;
      }

      if (this.isEditing) {
        if (this.wasEdited) {
          if (this.user) {
            this.localProfile.name = this.localUser.name;
          }
          this.localProfile.portion_size = parseFloat(this.localProfile.portion_size) || 1;
          this.$store
            .dispatch(
              this.profile.id ? "updateProfile" : "createNewProfile",
              this.localProfile,
            )
            .then(
              ({ success, data }) => {
                if (success) {
                  this.isEditing = false;
                  this.$emit("edit", this.localProfile);

                  if (this.temp_blob) {
                    this.$store.dispatch("uploadAvatar", {
                      profileId: data.profile.id,
                      avatar: this.temp_blob,
                      isCurrentProfile: !!this.user
                    }).then(() => {
                      this.temp_blob = null;
                      this.temp_url = null;
                    })
                  }
                } else {
                  this.hasError = true;
                }
              },
              error => {
                this.hasError = true;
                console.error("Error while saving user profile: %o", error);
              }
            );

            this.$store.dispatch('updateUser', this.preparedLocalUserData())

        } else if (this.profile.id) {
          this.isEditing = false;
          this.$emit("edit", this.localProfile);
        }
      } else {
        this.isEditing = true;
        this.wasEdited = false;
      }
    },
    editUserField(data) {
      this.wasEdited = true;
      if (data.name) {
        this.localUser[data.name] = data.value;
      }
    },
    editProfileField(data) {
      this.wasEdited = true;
      this.hasError = false;
      if (!this.localProfile) {
        this.localProfile = {};
      }
      if (data.name) {
        if (data.name == 'portion_size') data.value = parseFloat(data.value)
        this.localProfile[data.name] = data.value;
      }
    },

    switchMode(mode) {
      this.profileModeUser = mode;
    },
    avatarChangedHandler(event) {
      let file = event.target.files[0];
      this.$store.dispatch("uploadAvatar", {
        profileId: this.profile.id,
        avatar: file,
        isCurrentProfile: !!this.user
      });
    },
    onSaveAvatar(file) {
      if (this.profile.id) {
        this.$store.dispatch("uploadAvatar", {
          profileId: this.profile.id,
          avatar: file,
          isCurrentProfile: !!this.user
        });
      } else {
        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(file);
        this.temp_url = imageUrl;
        this.temp_blob = file;
      }
    },
    async removeProfileHandler() {
      if (typeof this.profile.id !== "undefined") {
        await this.$store.dispatch("deleteProfile", this.profile.id);
        this.toggleEditing(true);
        this.$emit("remove-new");
      } else {
        this.$emit("remove-new");
      }
    },
    preparedLocalUserData() {
      const fields = [
        'name',
        'email',
      ]

      const payload = {};
      for (let key in this.localUser) {
        if (fields.includes(key) && this.localUser[key]) {
          payload[key] = this.localUser[key]
        }
      }

      return payload;
    }
  }
};
</script>

<style lang="scss" scoped>
.k-profile__edit-button-img {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  color: white;
  padding: 5px;

  &.active {
    background: #f68c1e;
  }

  &.disabled {
    background: #c4c4c4;
  }
}

.k-profile__user-block-mode {
  display: flex;
  margin: 15px auto 0;
}
.k-profile-dot {
  background: #c4c4c4;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  margin: 0 5px;
  height: 8px;
  width: 8px;

  &.active {
    background: #f68c1e;
  }
}

.k-profile__avatar-overlay {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  display: flex;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.k-profile__avatar-overlay-img {
  display: flex;
  align-self: center;
  margin: auto;
}

.k-profile__remove-button {
  align-items: center;
  border-radius: 4px;
  display: flex;
  font-size: 20px;
  height: 30px;
  justify-content: center;
  line-height: 30px;
  margin-right: 10px;
  text-align: center;
  width: 30px;
}

.k-profile__edit-button {
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  color: #F68C1E;
}
.k-profile__profile-button{
  width: 100%;
  max-width: 320px;
  text-transform: uppercase;
  background: #F7981E;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  height: 60px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  cursor: pointer;

  &--red {
    background: #D51E3A;
  }
}

@media (max-width: 767.98px) {
  .k-profile__block-wrapper {
    background: unset;
    border: unset;
    box-shadow: unset;
    padding: 0 15px;
    max-width: 340px;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .k-profile__profile-button {
    height: 40px;
  }
}
</style>
